/**
 * Формат ошибки одинаков у всех эндпоинтов: { error: { code, message, details } }.
 * Ветвиться можно только по `code` — тексты меняются, и код, завязанный на message,
 * ломается от правки формулировки.
 */
export const API_ERROR_CODES = [
  'TENANT_REQUIRED', 'TENANT_NOT_FOUND', 'TENANT_ARCHIVED', 'TENANT_SUSPENDED',
  'INIT_DATA_REQUIRED', 'BAD_INIT_DATA', 'ROLE_REQUIRED', 'SUPER_REQUIRED',
  'SUBSCRIPTION_READONLY', 'SLOT_TAKEN', 'CHILD_BUSY', 'SLOT_NOT_IN_GRID',
  'CONTACT_REQUIRED', 'NOT_YOUR_CHILD', 'NOT_YOUR_APPOINTMENT',
  'INVITE_USED', 'INVITE_EXPIRED', 'BOT_NOT_CONFIGURED', 'LAST_LOCATION',
  'VALIDATION', 'NO_BOT', 'INTERNAL',
  'DIRECTION_EXISTS', 'DIRECTION_HAS_CHILDREN', 'DIRECTION_STAFF_MOVE_REQUIRED',
  'DIRECTION_MISMATCH', 'DIRECTION_NOT_FOUND', 'SERVICE_HAS_RATES', 'ALREADY_LINKED',
  'DIRECTION_REQUIRED', 'DIRECTION_HAS_RATES', 'DIRECTION_HAS_CLIENTS',
  'SELF_DEMOTE', 'LAST_ADMIN', 'ADMIN_NOT_FOUND', 'NO_SPECIALIST_CARD',
  'NOT_LINKED', 'SELF_TRANSFER', 'ALREADY_STAFF',
  'BAD_BOT_TOKEN', 'BOT_TAKEN', 'TELEGRAM_UNREACHABLE',
] as const;

export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: ApiErrorCode | string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  is(...codes: (ApiErrorCode | string)[]): boolean {
    return codes.includes(this.code);
  }
}

/** Сеть отвалилась или сервер не ответил — отдельный случай от «сервер сказал нет». */
export class NetworkError extends Error {
  readonly code = 'NETWORK';
  constructor(cause?: unknown) {
    super('Нет связи с сервером');
    this.name = 'NetworkError';
    this.cause = cause;
  }
}

export function isApiError(e: unknown): e is ApiError {
  return e instanceof ApiError;
}
